import Vue from 'vue';
import RouterService from "@/plugins/router.service";
import WorkerService from "@/plugins/worker.service";
import HttpService from "@/plugins/http.service";
import VueCookies from "vue-cookies"
import Vuetify from 'vuetify/lib'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import Viewer from "v-viewer";
const vuetify = new Vuetify({
    lang: {
        current: document.documentElement.lang
    }
})

Vue.use(RouterService);
Vue.use(WorkerService);
Vue.use(HttpService);
Vue.use(VueCookies);
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999
    }
});
Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'mdi'
})


